import axios from "axios";
import _ from "lodash";
import config from "../config/config";
import {
  decryptAesObjNew,
  encryptAes,
  encryptAesObjwithTime,
} from "../components/CommonComponents/AESencryptdecrypt"; // adjust path as needed

export const userService = {
  get,
  post,
  put,
  deleteDetail,
  loginService,
  postWithFile,
  getForCoreAPi,
  file,
  deletepayload,
  forgotePassword,
  postPlain,
  getVehiclePositions,
};

const isEncryptionEnabled = () => {
  return config.encryptionEnabled === true;
};

const preparePayload = (payload, timestamp) => {
  if (!isEncryptionEnabled()) {
    return payload;
  }
  const enc = encryptAesObjwithTime(payload, timestamp);
  return { payload: enc };
};

const processResponse = (data) => {
  if (!isEncryptionEnabled()) {
    return data;
  }
  try {
    return decryptAesObjNew(data);
  } catch (error) {
    console.warn("Skipping decryption:", error);
    return data;
  }
};

// log in Api without Header
function loginService(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let data = preparePayload(payload, dateslong);

  const headers = {
    userId: `__${sessionStorage.getItem("ipaddress")}`,
    timestamp: dateslong,
  };

  if (isEncryptionEnabled()) {
    headers.device = "WEB";
  }

  return axios({
    method: "post",
    url: apiEndpoint,
    data: data,
    headers: headers,
  })
    .then((response) => {
      let res = processResponse(response.data);
      console.log("[loginService] Decrypted response:", res);
      response.data = res;
      return response;
    })
    .catch((err) => {
      try {
        if (err.response && err.response.data) {
          let res = processResponse(err.response.data);
          err.response.data = res;
        }
      } catch (decryptError) {
        console.log(decryptError);
      }

      console.log(err);
      return err.response;
    });
}

function forgotePassword(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let data = preparePayload(payload, dateslong);

  const headers = {
    userId: `__${sessionStorage.getItem("ipaddress")}`,
    timestamp: dateslong,
  };

  if (isEncryptionEnabled()) {
    headers.device = "WEB";
  }

  return axios({
    method: "post",
    url: apiEndpoint,
    data: data,
    headers: headers,
  })
    .then((response) => {
      let res = processResponse(response.data);
      console.log("[forgotePassword] Decrypted response:", res);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
}

// get Api call common
function get(apiEndpoint, userId) {
  return axios
    .get(apiEndpoint, getOptions())
    .then((response) => {
      console.log("yashresp1212", response);
      response.data = processResponse(response.data);
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
      }
    });
}

// function get(apiEndpoint, userId) {
//   return axios
//     .get(apiEndpoint, getOptions())
//     .then((response) => {
//       return response;
//     })
//     .catch((err) => {
//       console.error("API Error:", err);
//       if (err.response && err.response.status === 401) {
//         // alert("⚠️ Session expired! Please log in again.");
//         // Optionally redirect to login
//         // window.open("/", "_self");
//       } else if (err.response) {
//         // alert(
//         //   `Error ${err.response.status}: ${
//         //     err.response.data?.message || "Something went wrong."
//         //   }`
//         // );
//       } else {
//         // alert("Network error! Please check your internet connection.");
//       }

//       throw err; // Re-throw if you want to handle it elsewhere
//     });
// }

function getForCoreAPi(apiEndpoint, userId) {
  return axios
    .get(apiEndpoint, getOptionsForCoreApi())
    .then((response) => {
      console.log(
        "[getForCoreAPi] Response from",
        apiEndpoint,
        ":",
        response.data,
      );
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
      }
    });
}

// Post Api call common
// function post(apiEndpoint, payload) {
//   let datetime = new Date();
//   let dateslong = Date.parse(datetime);
//   let enc = encryptAesObjwithTime(payload, dateslong);
//   let data = {
//     payload: enc,
//   };
//   return axios
//     .post(apiEndpoint, data, getOptions(dateslong))
//     .then((response) => {
//       let res = decryptAesObjNew(response.data);
//       console.log("[post] Decrypted response from", apiEndpoint, ":", res);
//       response.data = res;
//       return response;
//     })
//     .catch((err) => {
//       console.log(err);
//       if (err.response != undefined && err.response.status == 401) {
//         window.open("/", "_self");
//       } else {
//         return err.response;
//       }
//     });
// }

// Post Api call common
function post(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);

  console.log("postpayload", payload);

  const isFormData = payload instanceof FormData;

  let data;
  if (isFormData) {
    data = payload; // No encryption for FormData
  } else {
    data = preparePayload(payload, dateslong);
  }

  return axios
    .post(
      apiEndpoint,
      data,
      isFormData ? getOptionsFormData(dateslong) : getOptions(dateslong),
    )
    .then((response) => {
      let res = processResponse(response.data);
      console.log("[post] Decrypted response from", apiEndpoint, ":", res);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);

      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        try {
          if (err.response && err.response.data) {
            let res = processResponse(err.response.data);
            err.response.data = res;
          }
        } catch (decryptError) {}

        return err.response;
      }
    });
}

function postPlain(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);

  return axios
    .post(apiEndpoint, payload, getOptions(dateslong))
    .then((response) => {
      console.log("[postPlain] Response from", apiEndpoint, ":", response.data);
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return err.response;
      }
    });
}

// Put Api call common
function put(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let data = preparePayload(payload, dateslong);

  return axios
    .put(config.baseUrl + apiEndpoint, data, getOptions(dateslong))
    .then((response) => {
      let res = processResponse(response.data);
      console.log("[put] Decrypted response from", apiEndpoint, ":", res);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
      }
    });
}

// delete Api call common
function deleteDetail(apiEndpoint, payload) {
  return axios({
    method: "delete",
    url: apiEndpoint,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("data")).token,
    },
  })
    .then((response) => {
      console.log(
        "[deleteDetail] Response from",
        apiEndpoint,
        ":",
        response.data,
      );
      return response;
    })
    .catch((err) => {
      window.open("/", "_self");
    });
}

function deletepayload(apiEndpoint, payload) {
  return axios({
    method: "delete",
    url: apiEndpoint,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("data")).token,
    },
    data: payload,
  })
    .then((response) => {
      console.log(
        "[deletepayload] Response from",
        apiEndpoint,
        ":",
        response.data,
      );
      return response;
    })
    .catch((err) => {
      console.error("Error deleting permission:", err);
      return null;
    });
}

function getOptions(time) {
  let options = {};
  const sessionData = JSON.parse(sessionStorage.getItem("data"));

  if (sessionData && sessionData.token) {
    options.headers = {
      Authorization: "Bearer " + sessionData.token,
      userId: `${sessionData.id}__${sessionStorage.getItem("ipaddress")}__${sessionData.userType}`,
      timestamp: time,
    };

    if (isEncryptionEnabled()) {
      options.headers.device = "WEB";
    }
  }

  return options;
}

function getOptionsFormData(time) {
  let options = {};
  const sessionData = JSON.parse(sessionStorage.getItem("data"));

  if (sessionData && sessionData.token) {
    options.headers = {
      Authorization: "Bearer " + sessionData.token,
      userId: `${sessionData.id}__${sessionStorage.getItem("ipaddress")}__${sessionData.userType}`,
      timestamp: time,
    };

    if (isEncryptionEnabled()) {
      options.headers.device = "ENCODED";
    }
  }

  return options;
}

function getOptionsForCoreApi() {
  let options = {};
  const sessionData = JSON.parse(sessionStorage.getItem("data"));

  if (sessionData && sessionData.token) {
    options.headers = {
      Accept: "application/json",
      Authorization: "Basic " + btoa(`${config.Username}:${config.Password}`),
    };
  }

  return options;
}

function postWithFile(apiEndpoint, payload) {
  const sessionData = JSON.parse(sessionStorage.getItem("data"));

  const headers = {
    Authorization: "Bearer " + sessionData.token,
  };

  if (isEncryptionEnabled()) {
    headers.device = "ENCODED";
  }

  return axios({
    method: "post",
    url: apiEndpoint,
    data: payload,
    headers: headers,
  })
    .then((response) => {
      let res = processResponse(response.data);
      console.log(
        "[postWithFile] Decrypted response from",
        apiEndpoint,
        ":",
        res,
      );
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
}

async function file(apiEndpoint, payload) {
  return axios({
    method: "post",
    url: apiEndpoint,
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "sfa",
    },
  })
    .then((response) => {
      console.log("[file] Response from", apiEndpoint, ":", response.data);
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
}

function getVehiclePositions(apiEndpoint) {
  const sessionData = JSON.parse(sessionStorage.getItem("data"));

  return axios.get(apiEndpoint, {
    headers: {
      Accept: "application/json",
      ...(sessionData?.token
        ? { Authorization: "Bearer " + sessionData.token }
        : {}),
    },
  });
}
